module.exports = __webpack_public_path__ + "img/loader.7a49a17d.png";